import DeleteForever from "@mui/icons-material/DeleteForever";

import { ConfirmModal } from "components/ui/ConfirmModal";
import { Bucket, BucketNumberEnum } from "features/trading/buckets";

interface DeleteBucketConfirmModalProps {
  open: boolean;
  number: BucketNumberEnum;
  bucket: Bucket | undefined;
  confirming: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

/** Bucket-flavored confirmation for deleting a bucket, shared by the
 * Buckets tab and the edit modal. */
export const DeleteBucketConfirmModal = ({
  open,
  number,
  bucket,
  confirming,
  onClose,
  onConfirm,
}: DeleteBucketConfirmModalProps) => (
  <ConfirmModal
    open={open}
    title={`Delete Bucket ${number}?`}
    description={
      bucket
        ? `This removes the bucket and all ${bucket.assets.length} of its asset(s). The account's history is not affected.`
        : ""
    }
    confirmLabel="Delete"
    confirmColor="error"
    confirmIcon={<DeleteForever />}
    confirming={confirming}
    onClose={onClose}
    onConfirm={onConfirm}
  />
);
